import { createFileRoute, redirect } from "@tanstack/react-router";

import { roleHasPermission } from "@/auth/shared";
import { DirectorVenuesList } from "@/components/td/director-venues-list";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/td/venues")({
  loader: async ({ context: { viewer } }) => {
    const hasPermission =
      viewer &&
      roleHasPermission(viewer.role, {
        venues: ["update"],
      });

    if (!hasPermission) {
      throw redirect({ to: "/not-found" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DefaultLayout
      classNames={{
        content: "max-w-4xl px-4 py-16 mx-auto flex flex-col space-y-8",
      }}
    >
      <DirectorVenuesList />
    </DefaultLayout>
  );
}
